(function () {
  'use strict';

  function getScrollingElement() {
    return document.scrollingElement || document.documentElement;
  }

  function getScrollTop() {
    var el = getScrollingElement();
    return window.pageYOffset || el.scrollTop || document.body.scrollTop || 0;
  }

  function setScrollTop(y) {
    var el = getScrollingElement();
    el.scrollTop = y;
    document.documentElement.scrollTop = y;
    document.body.scrollTop = y;
    window.scrollTo(0, y);
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function smoothScrollToTop(duration, onComplete) {
    var startY = getScrollTop();
    if (startY <= 0) {
      setScrollTop(0);
      if (onComplete) onComplete();
      return;
    }

    var startTime = Date.now();

    function tick() {
      var elapsed = Date.now() - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeInOutCubic(progress);
      var nextY = Math.max(0, Math.round(startY * (1 - eased)));

      setScrollTop(nextY);

      if (progress < 1) {
        window.setTimeout(tick, 16);
      } else {
        setScrollTop(0);
        if (onComplete) onComplete();
      }
    }

    tick();
  }

  function initBackToTop() {
    var btn = document.getElementById('back-to-top');
    if (!btn || btn.dataset.backToTopInit === 'true') return;
    btn.dataset.backToTopInit = 'true';

    var threshold = 300;
    var isScrolling = false;

    function toggle() {
      if (isScrolling) return;

      if (getScrollTop() > threshold) {
        btn.hidden = false;
        btn.classList.add('back-to-top--visible');
      } else {
        btn.hidden = true;
        btn.classList.remove('back-to-top--visible');
      }
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (isScrolling) return;

      isScrolling = true;
      btn.disabled = true;

      smoothScrollToTop(1200, function () {
        isScrolling = false;
        btn.disabled = false;
        toggle();
      });
    });

    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackToTop);
  } else {
    initBackToTop();
  }

  document.addEventListener('shopify:section:load', initBackToTop);
})();
